import { render } from "./ChatLobby.vue?vue&type=template&id=643769b8&scoped=true"
import script from "./ChatLobby.vue?vue&type=script&lang=js"
export * from "./ChatLobby.vue?vue&type=script&lang=js"

import "./ChatLobby.vue?vue&type=style&index=0&id=643769b8&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643769b8"]])

export default __exports__